import type { ModuleRoute } from '@/platform/router/types';
const IaHome = () => <div>Em construção</div>;
export const iaRoutes: ModuleRoute[] = [{ path: '', label: 'IA & Automação', element: IaHome, requiredPermissions: [] }];
